import { Comment } from "./Comment";
import { Verification } from "./Verification";
import { OrderSerial } from "./OrderSerial";
import { CustomerApproval } from "./Order";
import { UserState } from "features/auth/types/user";

export interface Checklist {
  id: string;
  roomName: string;
  categories: Category[];
  creator: Creator;
  createdAt: string;
  finished: boolean | null;
  partOfOrder: string;
  internalComments: Comment[];
  additionalExtras: Comment[];
  verification: Verification[];
  noSerialsExplicitFlag: boolean;
  functionCheck: boolean;
  functionCheckBy: Author | null;
  functionCheckAt: string | null;
  functionCheckByAdmin: boolean;
  approved: boolean;
  approval: CustomerApproval | null;
  updatedAt: string | null;
  documentationDone: boolean;
  documentationDoneBy: Author | null;
  documentationDoneAt: string | null;
  allChecklists: string[];
  excludedFromReport: boolean;
  serialEntities: SerialEntity[];
  installedProducts: OrderSerial[];
}

export interface SerialEntity {
  index?: number | null;
  checklistId: string;
  id: string;
  serialNumber: string | null;
  maker: string | null;
  model: string | null;
  macAddress: string | null;
  networkSocket: string | null;
  other: string | null;
  noSerials: boolean;
  theftProtection: string | null;
  macAddressWifi: string | null;
  ipAddress: string | null;
  username: string | null;
  password: string | null;
}

export interface Author {
  userId: string;
  userName: string;
}

export interface Creator {
  id: string;
  userName: string;
  userCompany: string | null;
  userState: UserState | null;
}

export const Categories = {
  MEETING_ROOM: "Mötesrumslösningar",
  CLASSROOM: "Klassrum",
  CAFETERIA: "Matsal",
  SPORTS_HALL: "Idrottshall",
  AUDITORIUM: "Hörsal/Aula/ALC",
  DIGITAL_SIGNAGE: "Digital signage",
  LED_WALL: "LED-Vägg",
  CISCO: "Cisco",
  STUDIO_EVENT_CUSTOM: "Studio/Event/Speciallösningar",
  OTHER: "Annat",
} as const;

export type Category = keyof typeof Categories;
